import * as React from 'react';
import { Stack } from './stack';

type StackProps = React.ComponentProps<typeof Stack>;

export const VStack = (props: Omit<StackProps, 'axis'>) => {
  return <Stack axis="vertical" {...props} />;
};
